import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const googleSignIn = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) nav("/dashboard");
    else setError(r.error);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-cream">
      <div className="hidden md:flex flex-col justify-between bg-royal-800 text-cream p-12">
        <Link to="/" data-testid="login-brand" className="font-display text-3xl leading-none">FreLancTrac<span className="text-gold">.</span></Link>
        <div>
          <h1 className="font-display text-5xl leading-[0.98] font-medium">Ship work.<br />Track people.<br />Get paid on time.</h1>
          <p className="mt-6 text-cream/70 max-w-sm">A refined command center for freelancer studios — projects, work orders, performance, and INR payments in one royal-green dashboard.</p>
        </div>
        <div className="text-xs text-cream/50">© {new Date().getFullYear()} Oscorp · FreLancTrac</div>
      </div>

      <div className="flex items-center justify-center px-8 py-12">
        <div className="w-full max-w-sm">
          <div className="mb-8">
            <div className="label-caps mb-2">Sign in</div>
            <h2 className="font-display text-4xl">Welcome back.</h2>
          </div>

          <button
            type="button"
            data-testid="login-google"
            onClick={googleSignIn}
            className="w-full inline-flex items-center justify-center gap-3 h-11 rounded-lg border border-black/15 bg-white hover:bg-cream-2 text-sm font-medium">
            <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.9 0 6.6 1.7 8.1 3.1l6-5.8C34.5 3.4 29.7 1.5 24 1.5 14.9 1.5 7.1 6.8 3.3 14.4l7 5.4C12.1 14 17.6 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.2-.4-4.7H24v9h12.7c-.5 3-2.2 5.6-4.7 7.3l7.3 5.7c4.3-4 6.7-9.9 6.7-17.3z"/><path fill="#FBBC05" d="M10.3 28.6C9.7 27 9.4 25.3 9.4 23.5s.3-3.5.9-5.1l-7-5.4C1.7 16.4 0 19.8 0 23.5s1.7 7.1 3.3 10.5l7-5.4z"/><path fill="#34A853" d="M24 46.5c6.5 0 12-2.1 16-5.9l-7.3-5.7c-2 1.4-4.6 2.3-8.7 2.3-6.4 0-11.9-4.5-13.7-10.5l-7 5.4C7.1 40.2 14.9 46.5 24 46.5z"/></svg>
            Continue with Google
          </button>

          <div className="my-6 flex items-center gap-3 text-xs text-ink/40 font-mono-tight">
            <div className="flex-1 h-px bg-black/10" /> OR <div className="flex-1 h-px bg-black/10" />
          </div>

          <form onSubmit={submit} data-testid="login-form">
            <label className="label-caps block mb-1">Email</label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="rounded-lg border-black/20 focus-visible:ring-0 focus-visible:border-royal-700 mb-4 h-11" />
            <label className="label-caps block mb-1">Password</label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="rounded-lg border-black/20 focus-visible:ring-0 focus-visible:border-royal-700 h-11" />
            {error && (
              <div data-testid="login-error" className="mt-4 border border-[#B02A00] bg-white text-[#B02A00] px-3 py-2 text-sm rounded-lg">{error}</div>
            )}
            <button data-testid="login-submit" disabled={busy} type="submit" className="mt-6 w-full btn-primary disabled:opacity-50">
              {busy ? "Signing in…" : "Sign in →"}
            </button>
          </form>

          <div className="mt-6 text-sm text-ink/60 text-center">
            New here? <Link data-testid="login-goto-signup" to="/signup" className="text-royal-700 font-semibold hover:underline">Create an account</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
